<div class="set-deposit-limit-main-container text">
  <div class="transaction-header">{{ 'SELFLIMIT' | t }}</div>
  <div class="transaction-content-container">
    <div class="transaction-row">{{ 'Limit_Dialog_1' | t }}</div>
    <div class="transaction-row">{{ 'Limit_Dialog_2' | t }}</div>
    <div class="transaction-row">{{ 'Limit_Dialog_3' | t }}</div>
    <!-- <div class="transaction-row">{{"Example" | t}}   <b><u>{{"Limit_Dialog_4" | t}}  </u></b></div> -->
    <div class="transaction-row">
      <div class="transaction-row-left">{{ 'Example' | t }}</div>
      <div class="transaction-row-right-container">
        <div class="transaction-row-right">{{ 'Limit_Dialog_4' | t }}</div>
      </div>
    </div>
    <div class="transaction-row">
      <div class="transaction-row-left">{{ 'Notice' | t }}</div>
      <div class="transaction-row-right-container">
        <div class="transaction-row-right">{{ 'Limit_Dialog_5' | t }}</div>
        <div class="transaction-row-right">{{ 'Limit_Dialog_6' | t }}</div>
      </div>
    </div>
    <div class="transaction-row">
      <b
        ><u>{{ 'Limit_Dialog_7' | t }} </u></b
      >
    </div>
    <div class="form-container">
      <form action="" [formGroup]="selfLimitsData">
        <inputb3
          formControlName="DepositMonthlyLimitModel"
          extraClass="limitInputs"
          fErrorText="{{ 'Limit_Dialog_8' | t }}"
          fSuffixText="EUR"
          fPlaceholder="{{ 'Limit_Dialog_8' | t }}"
          fInputType="number"
          max="30000"
          min="1"></inputb3>
        <!-- <div class="form-container-row"><b>Last change:</b> 07.01.2022, 13:56 PM</div> -->
        <!-- <inputb3
  formControlName="password"

  fPlaceholder="{{'Password' | t}}"
  fInputType="password"

></inputb3> -->
        <div class="confirm-button-container">
          <div class="btn colored register-button save-changes-button confirm-button" *ngIf="this.selfLimitsData.valid; else noValid" (click)="saveSelfLimitsData()">
            <div class="btn-text">
              {{ 'Confirm_Settings' | t }}
            </div>
          </div>
          <ng-template #noValid>
            <div class="btn colored register-button save-changes-button confirm-button" style="opacity: 0.5">
              <div class="btn-text">
                {{ 'Confirm_Settings' | t }}
              </div>
            </div>
          </ng-template>
        </div>
      </form>
    </div>
  </div>
</div>
